import { Component, Input, TemplateRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { NgbActiveModal, NgbModal, NgbPaginationConfig } from '@ng-bootstrap/ng-bootstrap';
import { RecruitmentService } from 'src/app/services/recruitments.service';
import { RecruitmentDataService } from 'src/app/services/recruitment-data.service';
import { CandidateService } from 'src/app/services/recruitments/candidates.service';
import { FileService } from 'src/app/services/file.service';
import { LocalizationDataService } from 'src/app/services/data/localization-data.service';
import { LinkedInService } from 'src/app/services/integrations/linkedin.service';
@Component({
  selector: 'app-recruitment-list',
  templateUrl: './list.component.html',
  styleUrl: './list.component.scss'
})
export class ListComponent {
  @Input() recruitments: any[];
  @Input() isExternalCompany: boolean = true;
  filteredRecruitments: any[];
  recruitment: any;;
  page = 1;
  pageSize = 10;
  totalItems = 0;
  searchText: string = '';
  candidateId: number = 0;
  candidatesDropdown: any = [];
  @ViewChild('candidateFormModal') candidateFormModal: TemplateRef<any>; // Use TemplateRef
  document: any = null;

  constructor(
    private recruitmentService: RecruitmentService, 
    config: NgbPaginationConfig, 
    private router: Router,
    public recruitmentDataService: RecruitmentDataService,
    private modalService: NgbModal,
    private candidateService: CandidateService,
    private fileService: FileService,
    private linkedinService: LinkedInService,
    private localizationDataService: LocalizationDataService) {
    // customize default values of paginations used by this component tree
    config.pageSize = this.pageSize;
    config.maxSize = 5;
  }

  ngOnChanges(): void {
    this.applyFilter();
    this.getCandidates();
  }

  getCandidates() {
    this.candidateService.getCandidates().subscribe(candidates => {
      this.candidatesDropdown = candidates;
    });
  }

  onPageChange(page: number) {
    this.page = page;
  }

  onDelete(recruitmentId): void {
    if (confirm('Are you sure you want to delete this recruitment?')) {
      this.recruitmentService.deleteRecruitment(recruitmentId).subscribe(
        response => {
          // Handle successful deletion
          this.router.navigate(['/hr/recruitments']);
        },
        error => {
          // Handle error
        }
      );
    }
  } 

  clearSearch(): void {
    this.searchText = '';
    this.applyFilter();
  }

  applyFilter(): void {
    const searchTextLower = this.searchText.toLowerCase().trim();
    if (!searchTextLower) {
      this.filteredRecruitments = this.recruitments; // If search text is empty, show all recruitments
      return;
    }

    this.filteredRecruitments = this.recruitments.filter(recruitment => {
      return Object.values(recruitment).some(value => {
        if (value && typeof value === 'string') {
          return value.toLowerCase().includes(searchTextLower);
        }
        return false;
      });
    });
  }

  showCandidateForm(recruitment: any): void {
    this.recruitment = recruitment;
    this.modalService.open(this.candidateFormModal);
  }

  closeCandidateForm(): void {
    this.modalService.dismissAll();
  }

  onFileChange(event) {
    const file = (event.target as HTMLInputElement).files[0];
    if (file) {
      this.fileService.uploadFile(file, 'RecruitmentCandidate').subscribe(
        (uploadEvent: any) => {
          if (uploadEvent.body) {
            this.document = uploadEvent.body;
          }
        },
        error => {
          console.error('Upload error: ', error);
        }
      );
    }
  }

  save(): void {
    const data = {
      candidate_id: this.candidateId,
      document: this.document
    };
    
    this.recruitmentService.addCandidateToRecruitment(this.recruitment.id, data)
      .subscribe((res: any) => {
        this.recruitment.candidates.push(res);
        this.closeCandidateForm();
      });
  }

  get currency() {
    return this.localizationDataService.currency || {};
  }

  share(jobId: string) {
    this.linkedinService.redirectToLinkedIn(jobId);
  }
}
